import { css } from '@emotion/react';

export const availabilityBadgeSmallStyles = css`
  flex-shrink: 0;
  align-self: flex-start;
  width: max-content;
  max-width: 100%;
  white-space: nowrap;
`;

export const availabilityBadgeSmallLabelStyles = css`
  && {
    line-height: 14px;
    white-space: nowrap;
  }
`;

export const availabilityBadgeVariantStyles = {
  primary: css`
    background-color: var(--color-primary-100);
    color: var(--text-primary);
  `,
  success: css`
    background-color: var(--color-success-100);
    color: var(--text-primary);
  `,
  error: css`
    background-color: var(--surface-error);
    color: var(--text-error);
  `,
  action: css`
    background-color: var(--surface-action-2);
    color: var(--text-primary);
  `,
  featured: css`
    background-color: var(--surface-action-hover);
    color: var(--text-on-action);
  `,
  warning: css`
    background-color: var(--color-brown-200);
    color: var(--color-brown-900);
  `,
  neutral: css`
    background-color: var(--surface-neutral);
    color: var(--text-primary);
  `,
  plus: css`
    background-color: var(--color-gold-200);
    color: var(--text-primary);
  `,
  gold: css`
    background-color: var(--color-gold-500);
    color: var(--color-gold-900);
    text-transform: uppercase;
  `,
  limited: css`
    background-color: var(--color-primary-800);
    color: var(--text-on-action);
  `,
  booked: css`
    background-color: var(--color-accent-600);
    color: var(--text-on-action);
  `,
};
